import useSWR from "swr";
import OrderStatusService from "services/OrderStatusService";

const fetcher = () => OrderStatusService.getAll().then((res) => res.data);

const useOrderStatus = () => {
    const { data: orderStatuses = [] } = useSWR("order_statuses", fetcher);

    return orderStatuses;
};

export default useOrderStatus;
